<template>
    <div class="standardpage reports flights">
        <b-card class="m-0 lowpadding">
            <b-card-header class="px-3 m-0">
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="bankings.icon" class="mr-1"></i>
                        {{ bankings.title }}</b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0 mb-2">
                        <!-- <i class="fa fa-filter text-primary" @click="showfilter = !showfilter"></i> -->
                        <b-row v-if="!showfilter">

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Sort Code" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="sortno" placeholder="Sort Code" trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!sortno"
                                                @click="sortno = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Account No" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="accountno" placeholder="Account No" trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!accountno"
                                                @click="accountno = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Account Name" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="accountname" placeholder="Account Name"
                                            trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!accountname"
                                                @click="accountname = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Bank Name" label-size="sm">
                                    <b-input-group>
                                        <b-form-input v-model="bankname" placeholder="Bank Name" trim></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!bankname"
                                                @click="bankname = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>


                        </b-row>
                    </b-card-body>
                </b-card>
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="bankings" :selectall="bankings.selectall"
                        :icon="bankings.icon" :toolbarlibrary="bankings.toolbarlibrary" :tools="bankings.tools"
                        :icons="bankings.icons" :badges="bankings.badges" :fields="bankings.fields"
                        :items="bankings.items" :busy="bankings.busy" :offset="bankings.offset" :limit="bankings.limit"
                        :page="bankings.page" @load="bankings_load" @click="bankings_click" @select="bankings_select">
                    </d-table>
                </div>
            </div>

            <div v-if="component">
                <component :is="component" :selection="bankings.selected"
                    :parent_id="bankings.selected.length > 0 ? bankings.selected[0].id : ''" :config="cconfig"
                    @discard="bankings_click('discard')"></component>
            </div>
        </b-card>
    </div>
</template>

<script>
import gql from "graphql-tag";
import BankingsEdit from "./Components/BankingsEdit";

export default {
    name: "Banking",
    components: {
        BankingsEdit,
    },
    async mounted() {
        await this.accessdenied();
        await this.bankings_load();
    },
    watch: {

        async accountname() {
            await this.bankings_load(0);
        },
        async accountno() {
            await this.bankings_load(0);
        },
        async sortno() {
            await this.bankings_load(0);
        },
        async bankname() {
            await this.bankings_load(0);
        },
        async type() {
            await this.bankings_load(0);
        },
    },
    data() {
        return {
            busy: false,
            id: null,
            accountname: null,
            accountno: null,
            sortno: null,
            bankname: null,
            type: null,
            bankings: {
                title: "Bank Feeds",
                icon: "fa fa-university text-primary",
                debounce: 500,
                busy: false,
                showpages: true,
                page: 1,
                offset: 0,
                limit: 15,
                denied: [],
                toolbarlibrary: [
                    {
                        type: "button",
                        size: "sm",
                        variant: "outline-white",
                        squared: "squared",
                        icon: "fa fa-link text-orange",
                        position: "toolbar,actions",
                        action: "match",
                        label: "Match",
                        component: {
                            name: "",
                        },
                    },
                ],
                tools: "go,filter,export,clipboard,add,edit,deleteconfirm,match",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-center w-30px",
                    },
                    {
                        key: "accountname",
                        label: "Account Name",
                        sortable: true,
                    },
                    {
                        key: "type",
                        label: "Type",
                        sortable: true,
                    },
                    {
                        key: "accountno",
                        label: "Account No",
                        sortable: true,
                        formatter: (value, key, item) => {
                            return item.sortno + "-" + item.accountno

                        },
                    },
                    {
                        key: "unmatched",
                        label: "Unmatched",
                        sortable: true,
                        totalled: true,
                        type: "Int",
                        total: 0,
                    },
                    {
                        key: "currency",
                        label: "Currency",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "balance",
                        label: "Balance",
                        sortable: true,
                        class: "text-right",
                        formatter: (value, key, item) => {
                            if (value) {
                                return parseFloat(value).toFixed(2);
                            } else {
                                return value;
                            }
                        },
                        totalled: true,
                        total: 0,
                    },
                    {
                        key: "balance_at",
                        label: "Balance At",
                        sortable: true,
                        class: "text-center",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000)
                                    .format("DD/MM/YYYY");
                            }
                            return result;
                        },
                    },
                    {
                        key: "isactive",
                        label: "Active",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "isdashboard",
                        label: "Dashboard",
                        sortable: true,
                        class: "text-center",
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-center d-none d-sm-table-cell",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-110px",
                    },
                ],
                icons: [
                    {
                        key: "type",
                        ['1']: "fa fa-university text-primary w-15px text-center",
                        ['-1']: "fa fa-university text-danger w-15px text-center",
                    }
                ],
                badges: [
                    {
                        key: "type",
                        type: "badge",
                        credit: "success",
                        debit: "danger",

                        // formatter: (value, key, item) => {
                        //     switch (value) {
                        //         case "1":
                        //             return "Credit";

                        //         case "-1":
                        //             return "Debit";

                        //         default:
                        //             return value;
                        //     }
                        // },
                    },
                    {
                        key: "accountno",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "unmatched",
                        type: "pill",
                        class: "danger",
                    },
                    {
                        key: "currency",
                        type: "pill",
                        class: "white",
                    },
                    {
                        key: "reconcile",
                        type: "pill",
                        class: "danger",
                    },
                    {
                        key: "isdashboard",
                        type: "badge",
                        Yes: "success",
                        No: "danger",
                        formatter: (value, key, item) => {
                            switch (value) {
                                case "true":
                                    return "Yes";

                                case "false":
                                    return "No";

                                default:
                                    return value;
                            }
                        },
                    },
                    {
                        key: "isactive",
                        type: "badge",
                        Yes: "success",
                        No: "danger",

                        formatter: (value, key, item) => {
                            switch (value) {
                                case "true":
                                    return "Yes";

                                case "false":
                                    return "No";

                                default:
                                    return value;
                            }
                        },
                    },
                ],
                items: [],
                selected: []
            },
        };
    },

    methods: {

        accessdenied() {
            this.bankings.denied = [];

            if (!this.user.permissions.includes("bankings.delete")) {
                this.bankings.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("bankings.save")) {
                this.bankings.denied.push("save");
            }
        },

        async bankings_load(offset, limit, page) {
            let state = this.bankings;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                sortno: this.sortno,
                accountno: this.accountno,
                accountname: this.accountname,
                bankname: this.bankname,
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query bankings(
                            $offset: Int
                            $limit: Int
                            $sortno: String
                            $accountno: String
                            $accountname: String
                            $bankname: String
                        ) {
                            bankings(
                            offset: $offset
                            limit: $limit
                            sortno: $sortno
                            accountno: $accountno
                            accountname: $accountname
                            bankname: $bankname                  
                        ) {
                            id
                            sortno
                            accountno
                            accountname                    
                            bankname   
                            currency
                            balance_at
                            balance       
                            unmatched                  
                            isactive   
                            isdashboard 
                            type
                            blac
                            updated_by
                            updated_at
                        }
                        }
                    `,
                    variables,
                });

                if (limit == 0) {
                    state.selected = response.data.bankings
                } else {
                    state.items = []
                    state.items = response.data.bankings;
                }

            } catch (error) {
                console.log(error);
            }
            state.busy = false;
        },

        async bankings_click(a, ss) {

            switch (a) {
                case "selectall":
                    await this.bankings_load(0, 0);
                    break;
                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                case "go":
                    this.component = null;
                    await this.bankings_load();
                    break;
                case "add":
                case "edit":
                    this.component = "BankingsEdit";
                    break;
                case "match":
                    this.bankings_match(ss);
                    break;
                case "delete":
                    this.bankings_delete(ss);
                    break;
            }
        },
        async bankings_select(ss, tools) {

            let state = this.bankings;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "save", "go", "filter", "export", "add", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "match",];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

        async bankings_delete(ss) {
            console.log("bankings_delete", ss);

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            console.log(variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
            mutation bankings_delete($rows: [Banking_input]) {
                bankings_delete(rows: $rows) {
                id
              }
            }
          `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.bankings_load(0);
        },
        async bankings_match(ss) {
            let state = this.bankings;

            if (await this.$bvModal.msgBoxConfirm('Data is automatically reconciled against the Backoffice.', {
                title: 'Please confirm you want to reconcile this statement?',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })) {
                state.busy = true

                let variables = {
                    account_id: ss[0].id,
                }
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation bankingslines_match ($account_id:String) {
                            bankingslines_match (account_id: $account_id) 
                        }
                        `,
                    variables,
                });

                state.busy = false
            } else {
                state.busy = false
            }

            await this.bankings_load(0);
        },


    },
};
</script>